import type { FC } from "react"
import { IconCheckOutline18 as Check } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/cn"
import { Avatar } from "@productlane/ui"
import { CommandItem } from "@productlane/ui/src/components/internal/command"

import type { SharedFilterItemsProps } from "./types"
import { useSlackWorkspaceOptions } from "@/lib/slack-workspaces"
import { useThreadsFilterState } from "../threads-filter-state"

export const SlackWorkspaceFilterItems: FC<SharedFilterItemsProps> = ({
	onSelect,
}) => {
	const { slackWorkspaceIds, addSlackWorkspace, removeSlackWorkspace } =
		useThreadsFilterState()
	const workspaces = useSlackWorkspaceOptions()

	return (
		<>
			{workspaces.map((workspace) => {
				const isSelected = slackWorkspaceIds.includes(workspace.id)
				return (
					<CommandItem
						key={workspace.id}
						value={workspace.name}
						onSelect={() => {
							if (isSelected) removeSlackWorkspace(workspace.id)
							else addSlackWorkspace(workspace.id)
							onSelect()
						}}
					>
						<div className="flex w-full items-center gap-2">
							<Avatar
								name={workspace.name}
								image={workspace.iconUrl ?? undefined}
								roundness="sm"
								size="xs"
								className="flex-none"
							/>
							<span className="flex-1 truncate">{workspace.name}</span>
							<Check
								className={cn("h-4 w-4 shrink-0", {
									"opacity-100": isSelected,
									"opacity-0": !isSelected,
								})}
							/>
						</div>
					</CommandItem>
				)
			})}
		</>
	)
}
